/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fc_Home_Features_Audio_TitleInputs */

const en_fc_home_features_audio_title = /** @type {(inputs: Fc_Home_Features_Audio_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Broadcast audio`)
};

/**
* | output |
* | --- |
* | "Broadcast audio" |
*
* @param {Fc_Home_Features_Audio_TitleInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const fc_home_features_audio_title = /** @type {((inputs?: Fc_Home_Features_Audio_TitleInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fc_Home_Features_Audio_TitleInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_fc_home_features_audio_title(inputs)
});
export { fc_home_features_audio_title as "fc.home.features.audio.title" }